import React from 'react';
import { useDevelopmentDemo } from '../../contexts/DevelopmentDemoContext';
import { DemoSectionHeader } from '../demoShell/DemoSectionHeader';
import { HistoryControls } from '../demoShell/HistoryControls';
import { downloadJson, formatTimestamp } from '../../utils/demoStorage';
import { devExport } from '../../utils/developmentDemo';
export function DevHistory() {
  const {
    state,
    config,
    reset
  } = useDevelopmentDemo();
  const participantView = state.ui.workspace === 'participant';
  const events = participantView ? state.history.filter(event => event.participantId === state.ui.actingParticipantId) : state.history;
  const shortName = {
    education: 'Education',
    talent: 'Talent',
    leadership: 'Leadership',
    community: 'Community'
  }[config.id];
  return <div data-id="element-586" data-mp="10tzexiw4lssm">
      <DemoSectionHeader title="History & Controls" description={participantView ? 'Everything recorded for this record, newest first.' : `Every submission, review, activity${config.features.comparison ? ', decision' : ''}${config.features.referrals ? ', referral' : ''} in ${config.productLabel}, newest first.`} data-id="element-587" data-mp="d6812auxt7p8" />
      <div className="grid grid-cols-1 gap-8 xl:grid-cols-[minmax(0,7fr)_minmax(0,4fr)]" data-id="element-588" data-mp="hbv1k7hnwmt8">
        {events.length === 0 ? <p className="text-ink-muted" data-id="element-589" data-mp="ma6a8ew80r9v">No activity recorded yet.</p> : <ol className="divide-y divide-line border-y border-line" data-id="element-590" data-mp="3ktwrbvn34i7o">
            {events.map(event => <li key={event.id} className="py-3" data-id="element-591" data-mp="3pt99w46xb34g">
                <p className="text-xs text-ink-muted" data-id="element-592" data-mp="3pu15hf0it0uq">
                  <span className="font-mono" data-id="element-593" data-mp="3uqhx4j6xhxck">{event.id}</span> · {formatTimestamp(event.at)}
                </p>
                <p className="mt-0.5 text-ink-dark" data-id="element-594" data-mp="2p1rphqww98f">{event.action}</p>
              </li>)}
          </ol>}
        <div className="xl:sticky xl:top-28 xl:self-start" data-id="element-595" data-mp="1a3enhz5n8eyx">
          <HistoryControls domainName={shortName} exportLabel={`Export ${shortName.toLowerCase()} records`} onExport={() => downloadJson(`noetivra-${config.id}-records.json`, devExport(config, state))} onReset={reset} data-id="element-596" data-mp="1e1ccb0vi4z1s" />
        </div>
      </div>
    </div>;
}